import { matchRoutes, useLocation } from 'react-router-dom';

import { AppRoutePatterns } from '../../routes';

const articleRoutes = [{ path: AppRoutePatterns.ArticleByUri }, { path: AppRoutePatterns.ArticleById }];

export const useIsArticleSidebarOpen = (): boolean => {
  const location = useLocation();
  return !!matchRoutes(articleRoutes, location);
};
